<template>
  <div class="px-2">
<div v-if="user.username!='Guest'">
    <v-radio-group :disabled="loading" class="switch-field1" @change="setIsCreatedOrviewStories()" v-model="isCreatedOrviewStories" row background-color="white"
      active-class="active1">
      <v-radio id="radio-two" name="switch-one" :label="$t('createdStories')" :value="0"></v-radio>
      <v-radio id="radio-one" name="switch-one" :label="$t('viewStories')" :value="1"></v-radio>
    </v-radio-group>

    <v-radio-group :disabled="loading" v-if="isCreatedOrviewStories" @change="setIsAllOrNearme()" class="switch-field2" v-model="isAllOrNearme" row
      active-class="active2">
      <v-radio id="radio-two" name="all" :label="$t('allStories')" :value="0" ></v-radio>
      <v-radio id="radio-one" name="nearMe" :label="$t('nearMe')" :value="1" >
      </v-radio>
    </v-radio-group>

    <v-radio-group :disabled="loading" v-else class="switch-field3" v-model="isSavedOrPublished" @change="setIsSavedOrPublished()" row active-class="active3">
      <v-radio id="radio-five" name="createdStories" :label="$t('saved')" :value="0" >
      </v-radio>
      <v-radio id="radio-six" name="viewStories" :label="$t('published')" :value="1">
      </v-radio>
    </v-radio-group>
</div>
<div v-else>
<div class="mx-2 mt-2 mb-2">{{$t('viewStories')}}</div>

    <v-radio-group :disabled="loading" v-if="isCreatedOrviewStories" @change="setIsAllOrNearme()" class="switch-field2" v-model="isAllOrNearme" row
      active-class="active2">
      <v-radio id="radio-two" name="all" :label="$t('allStories')" :value="0" ></v-radio>
      <v-radio id="radio-one" name="nearMe" :label="$t('nearMe')" :value="1" >
      </v-radio>
    </v-radio-group>
</div>

    <v-row class="text-center">
      <v-col cols="12" class="pb-0 mt-0 mb-0 pt-0 pb-0">
        <v-btn :disabled="loading" v-if="$route.name=='home'" class="px-0" text big
          @click="gotopage('/map')">
          <i class=" mdi mdi-map-marker"></i> <span style="text-transform: initial!important;">{{ $t("viewOnMap") }}</span>
        </v-btn>
        <v-btn :disabled="loading" v-if="$route.name=='map'" class="px-0 mt-2 mb-2 text-uppercase" text big
          @click="gotopage('/home')">
          <i class=" mdi mdi-view-list"></i> <span style="text-transform: initial!important;">{{$t('backToListView')}}</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//this page is displayed when an error occurs
import { mapState } from 'vuex';
export default {
  name: 'homeToggleFilters',
  components: {
  },
    data: () => ({
    getUserCoordinates:null,

    apiUrl: process.env.VUE_APP_ROOT_API,

    //first tab show when logged user not Guest
    isCreatedOrviewStories:0,
    //second tab when first tab=1
    isAllOrNearme:0,
    //third tab when first tab=0
    isSavedOrPublished:0,

    // filtered stories
    filteredMyStoriesSavedList: [],
    filteredMyStoriesPublishedList: [],
    filteredAllStoriesPublic:[],
    filteredStoriesListNearMe: [],

//the stories from api without filter
    myStoriesSavedList: [],
    myStoriesPublishedList:[],
    allStoriesPublic:[],
    storieslistNearMe: [],

    listOfFilterTag: [],
    locationslist: [],

    textSearchStoryTitle: "",
    changeText: "",

  }),
    computed: {
    isToggleJourneyView: {
      get: function () {
        return this.$store.getters.getIsJourneyOrSingleStory;
      }
    },
      loading: function(){
        return this.$store.getters.getLoading;
    },
    ...mapState(['user'])
  },
    async mounted() {



//TO DO CHECK IF GPS IS ON 

/*
var options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0
};

function success(pos) {
  var crd = pos.coords;

  console.log('Your current position is:');
  console.log(`Latitude : ${crd.latitude}`);
  console.log(`Longitude: ${crd.longitude}`);
  console.log(`More or less ${crd.accuracy} meters.`);
}

function error(err) {
  console.error(`ERROR -------(${err.code}): ${err.message}`)
              this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: `ERROR -------(${err.code}): ${err.message}`,
              active: true
            })
}

navigator.geolocation.getCurrentPosition(success, error, options);
*/


    this.$getLocation()
      .then(response => {
        this.getUserCoordinates = response
      })

      if (this.$store.getters.getIsCreatedOrviewStories){
            this.isCreatedOrviewStories = this.$store.getters.getIsCreatedOrviewStories
      }
      this.isAllOrNearme = this.$store.getters.getIsAllOrNearme
      this.isSavedOrPublished = this.$store.getters.getIsSavedOrPublished

    if (this.user.username=='Guest'){
      this.$store.dispatch('setIsCreatedOrviewStories',1)
      this.$store.dispatch('setIsAllOrNearme',0)
    }

    //clear temp information story - used for create or edit
    this.$store.dispatch("clearNewStory")
    this.$indexdb.mediaFiles.clear()
    //retrive stories from DB
    await this.getAllStoriesPublic()
    await this.getUserStoriesDraft()
    await this.getUserStoriesPublic()
    await this.getStoriesNearMe()

    this.dispatchAllFilteredStories()


    if (this.$store.getters.getListOfSelectedTag.length > 0) {
            this.$store.dispatch('setLoading', true)
      this.listOfFilterTag = this.$store.getters.getListOfSelectedTag
      await this.filterAllStoriesPublic()
      await this.filterMyStoriesSavedList()
      await this.filterMyStoriesPublishedList()
//      await this.filterStoriesListNearMe()

      this.dispatchAllFilteredStories()
            this.$store.dispatch('setLoading', false)

    } else {
            this.$store.dispatch('setLoading', true)
      this.filteredMyStoriesSavedList=this.myStoriesSavedList
      this.filteredMyStoriesPublishedList= this.myStoriesPublishedList
      this.filteredAllStoriesPublic=this.allStoriesPublic
      this.filteredStoriesListNearMe=this.storieslistNearMe

      this.dispatchAllFilteredStories()
            this.$store.dispatch('setLoading', false)
    }
  },


  methods: {
    dispatchAllFilteredStories:function(){
      this.$store.dispatch('setCurrentAllPublicStories',this.filteredAllStoriesPublic)
      this.$store.dispatch('setCurrentAllPublicNearMeStories',this.filteredStoriesListNearMe)
      this.$store.dispatch('setCurrentUserStoriesDraft',this.filteredMyStoriesSavedList)
      this.$store.dispatch('setCurrentUserStoriesPublished',this.filteredMyStoriesPublishedList)
    },
    // save the current btn selection in store
    setIsCreatedOrviewStories:function(){
      this.$store.dispatch('setIsCreatedOrviewStories',this.isCreatedOrviewStories)
    },
        // save the current btn selection in store
    setIsAllOrNearme:function(){
      this.$store.dispatch('setIsAllOrNearme',this.isAllOrNearme)
    },
        // save the current btn selection in store
    setIsSavedOrPublished:function(){
      this.$store.dispatch('setIsSavedOrPublished',this.isSavedOrPublished)
    },
    //change the page
    gotopage: function (page) {
      this.$router.push(page)
    },

    filterMyStoriesSavedList() {
      try {
        if (this.listOfFilterTag.length == 0 || this.textSearchStoryTitle != null || this.textSearchStoryTitle != "") {
          this.filteredMyStoriesSavedList = []
          this.filteredMyStoriesSavedList = this.myStoriesSavedList.filter(function (item) {
            if ((this.textSearchStoryTitle != "" || this.textSearchStoryTitle != null) && this.listOfFilterTag.length == 0) {
              if (item.title.toLowerCase().includes(this.textSearchStoryTitle.toLowerCase())) {
                return true
              }
            } else if ((this.textSearchStoryTitle == "" || this.textSearchStoryTitle == null) && this.listOfFilterTag.length > 0) {
              for (const tag of item.tags) {
                if (this.listOfFilterTag.includes(tag.tag)) {
                  return true
                }
              }
            } else {
              for (const tag of item.tags) {
                if (this.listOfFilterTag.includes(tag.tag) && item.title.toLowerCase().includes(this.textSearchStoryTitle.toLowerCase())) {
                  return true
                }
              }
            }
          }.bind(this))
        } else {
          this.filteredMyStoriesSavedList = this.myStoriesSavedList
        }
      } catch (error) {
        console.log(error);
      }
    },

    filterMyStoriesPublishedList() {
      try {
        if (this.listOfFilterTag.length > 0 || this.textSearchStoryTitle != null || this.textSearchStoryTitle != "") {
          this.filteredMyStoriesPublishedList = []
          this.filteredMyStoriesPublishedList = this.myStoriesPublishedList.filter(function (item) {
            if (this.textSearchStoryTitle != null && this.listOfFilterTag.length == 0) {
              if (item.title.toLowerCase().includes(this.textSearchStoryTitle.toLowerCase())) {
                return true
              }
            } else if ((this.textSearchStoryTitle == "" || this.textSearchStoryTitle == null) && this.listOfFilterTag.length > 0) {
              for (const tag of item.tags) {
                if (this.listOfFilterTag.includes(tag.tag)) {
                  return true
                }
              }
            } else {
              for (const tag of item.tags) {
                if (this.listOfFilterTag.includes(tag.tag) && item.title.toLowerCase().includes(this.textSearchStoryTitle.toLowerCase())) {
                  return true
                }
              }
            }
          }.bind(this))
        } else {
          this.filteredMyStoriesPublishedList = this.myStoriesPublishedList
        }
      } catch (error) {
        console.log(error);
      }
    },

    filterAllStoriesPublic() {
      try {
        if (this.listOfFilterTag.length > 0 || this.textSearchStoryTitle != null || this.textSearchStoryTitle != "") {
          this.filteredAllStoriesPublic = []
          this.filteredAllStoriesPublic = this.allStoriesPublic.filter(function (item) {
            if (this.textSearchStoryTitle != null && this.listOfFilterTag.length == 0) {
              if (item.title.toLowerCase().includes(this.textSearchStoryTitle.toLowerCase())) {
                return true
              }
            } else if ((this.textSearchStoryTitle == "" || this.textSearchStoryTitle == null) && this.listOfFilterTag.length > 0) {
              for (const tag of item.tags) {
                if (this.listOfFilterTag.includes(tag.tag)) {
                  return true
                }
              }
            } else {
              for (const tag of item.tags) {
                if (this.listOfFilterTag.includes(tag.tag) && item.title.toLowerCase().includes(this.textSearchStoryTitle.toLowerCase())) {
                  return true
                }
              }
            }
          }.bind(this))
        } else {
          //console.log("filter null","this.allStoriesPublic",this.allStoriesPublic)
          this.filteredAllStoriesPublic = this.allStoriesPublic
        }
      } catch (error) {
        console.log(error);
      }
    },
//2
    filterStoriesListNearMe() {
      try {
        if (this.listOfFilterTag.length > 0 || this.textSearchStoryTitle != null || this.textSearchStoryTitle != "") {
          this.filteredStoriesListNearMe = []
          this.filteredStoriesListNearMe = this.storieslistNearMe.filter(function (item) {
            if (this.textSearchStoryTitle != null && this.listOfFilterTag.length == 0) {
              if (item.title.toLowerCase().includes(this.textSearchStoryTitle.toLowerCase())) {
                return true
              }
            } else if ((this.textSearchStoryTitle == "" || this.textSearchStoryTitle == null) && this.listOfFilterTag.length > 0) {
              for (const tag of item.tags) {
                if (this.listOfFilterTag.includes(tag.tag)) {
                  return true
                }
              }
            } else {
              for (const tag of item.tags) {
                if (this.listOfFilterTag.includes(tag.tag) && item.title.toLowerCase().includes(this.textSearchStoryTitle.toLowerCase())) {
                  return true
                }
              }
            }
          }.bind(this))
        } else {
          //console.log("filter null","this.allStoriesPublic",this.allStoriesPublic)
          this.filteredStoriesListNearMe = this.storieslistNearMe
        }
      } catch (error) {
        console.log(error);
      }    
      },

    async getAllStoriesPublic() {
      try {

        let completeurl = this.apiUrl + '/getPublicStories?content=true&short=100'
        let tempStorieslist
        tempStorieslist = await this.getaxiosResponse(completeurl)
        this.allStoriesPublic = tempStorieslist.data

      } catch (error) {
        if (error.response.status== 401){
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
          
        }
        else if (error.response.status== 401){
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          }).then(()=>this.gotopage('/splashScreen'))
        }
      else {
        this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
        }
      }
    },
    async getUserStoriesPublic() {
      try {
        let completeurl = this.apiUrl + '/getUserStoriesPublic?content=true&short=100'
        let tempUserStoriesPublic
        tempUserStoriesPublic = await this.getaxiosResponse(completeurl)
        this.myStoriesPublishedList = tempUserStoriesPublic.data
      } catch (error) {
        if (error.response.status== 401){
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
          
        }
        else if (error.response.status== 401){
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          }).then(()=>this.gotopage('/splashScreen'))
        }
      else {
        this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
        }

      }
    },
    async getUserStoriesDraft() {
      try {

        let completeurl = this.apiUrl + '/getUserStoriesDraft?content=true&short=100'
        let tempGetUserStoriesDraft
        tempGetUserStoriesDraft = await this.getaxiosResponse(completeurl)
        this.myStoriesSavedList = tempGetUserStoriesDraft.data
      } catch (error) {
        if (error.response.status== 401){
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
          
        }
        else if (error.response.status== 401){
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          }).then(()=>this.gotopage('/splashScreen'))
        }
      else {
        this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
        }

      }
    },
    // retrive all the stories Near the user position
  
    async getStoriesNearMe() {
      try {
        let completeurl
        if(this.getUserCoordinates!=null){
          completeurl = this.apiUrl + '/getNearStories?latitude=' + this.getUserCoordinates.lat + '&longitude=' + this.getUserCoordinates.lng + '&meters=50000&short=100&content=true&limit=20'
        }
        else{
          this.$store.dispatch("setSnackbar", {
            color: 'error',
            text: this.$i18n.t('noCoordinates'),
            active: true
          })
          completeurl = this.apiUrl + '/getNearStories?latitude=' + this.$store.getters.getUser.latitude + '&longitude=' + this.$store.getters.getUser.longitude + '&meters=50000&short=100&content=true&limit=20'
        }

        let tempStoriesNearMeList
        tempStoriesNearMeList = await this.getaxiosResponse(completeurl)
        this.storieslistNearMe = tempStoriesNearMeList.data
        this.storieslistNearMe
        //error in KG latitude and longitude are reversed
        this.storieslistNearMe = this.storieslistNearMe.map(function(row) {
        return { id : row.id, title : row.title,shortDescription:row.shortDescription,latitude:row.latitude,longitude:row.longitude,cover_image:row.cover_image,user:row.user,created_at:row.created_at}
      })
      } catch (error) {
        if (error.response.status== 400){
          this.storieslistNearMe=[]
          /*
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })*/
        }
      else {
        /*
        this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: this.$t("serverError")+error.response.data,
            active: true
          })
          */
        }
      }
    },


  },
    watch: {
    '$store.state.isStoryEditediNeedToReloadStories': function () {
     this.getAllStoriesPublic()
     this.getUserStoriesDraft()
     this.getUserStoriesPublic()
     this.getStoriesNearMe()

      this.filterAllStoriesPublic()
      this.filterMyStoriesSavedList()
      this.filterMyStoriesPublishedList()
      this.filterStoriesListNearMe()
        this.$store.dispatch('setisStoryEditediNeedToReloadStories', true)

    this.dispatchAllFilteredStories()
          },
    '$store.state.searchBarTextValue': function () {
      this.textSearchStoryTitle = this.$store.getters.getSearchBarTextValue
      this.$store.dispatch('setLoading', true)

      this.filterAllStoriesPublic()
      this.filterMyStoriesSavedList()
      this.filterMyStoriesPublishedList()
      this.filterStoriesListNearMe()

      this.dispatchAllFilteredStories()
      this.$store.dispatch('setLoading', false)

    },
    '$store.state.listOfSelectedTag': function () {
      this.listOfFilterTag = this.$store.getters.getListOfSelectedTag
      this.$store.dispatch('setLoading', true)

      this.filterAllStoriesPublic()
      this.filterMyStoriesSavedList()
      this.filterMyStoriesPublishedList()
      this.filterStoriesListNearMe()

      this.dispatchAllFilteredStories()
      this.$store.dispatch('setLoading', false)
}
  }
}
</script>
<style>
.v-input--selection-controls {
    padding-top: 0px !important;
}
.v-input.switch-field2.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot > div,
.v-input.switch-field3.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot > div{
  background-color: #e5e5e5;
  border-radius: 99rem;
}

.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
}
.v-input__slot{
  margin-bottom: 0px;
}
/* v-radio btn 1*/
.theme--light.v-label{
  color: black;
}

.v-input--radio-group.v-input--radio-group--row .v-radio {
    margin-right: auto;
    margin-left: auto;
    width: 48%;
    text-align: center;
}
.v-input--radio-group.v-input--radio-group--row .v-radio > .v-label{
  padding: auto auto;
  text-align: center;
}
.switch-field1 .v-radio .active1 label{
  background-color: #81B9BF;
  border-radius: 99rem!important;
}
.active1 {
  color:#38737A;
  border-radius: 999rem;
}
.active2,.active3{
  background-color: #38737A;
  border-radius: 999rem;
}
div.v-radio.theme--light.active3 > label,div.v-radio.theme--light.active2 > label{
    color: white!important;
}
.switch-field1.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;

}
.switch-field2.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;
  padding: 0px 5vh;

}
.switch-field3.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;
  padding: 0px 5vh;

}
.v-input.switch-field1.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot.white > div > div.v-radio.theme--light > div{
  display: none;
}
.v-application--is-ltr .v-input--selection-controls__input {
    display: none;
}

/* end v-radio btn */
.v-tab--disabled {
    pointer-events: none;
    opacity: 1;
}
.v-btn--fab.v-size--x-large {
    height: 100px;
    width: 100px;
}
.rounded-circle{
  border-radius: 50%;
  padding: 10%;
}
.rounded-circle span{
white-space: inherit;
}
.w3-badge{
  border-radius: 50%;
    background-color: gray;
    color: #fff;
    display: inline-block;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    text-align: center;
    line-height: 1.5rem;
}
.border-bottom-grey{
  border-bottom: 1px solid gray;
}
.styleimgthumbnails{
max-width: 90%;
}
.ctadashboard{
  text-transform: capitalize;
}
.ctareadMore{
    text-transform: capitalize;
    color:#AAA
}
.styleimgheritageFull{
  width: 40%;
}
.titleHeritrage{
  text-transform: capitalize;
  font-size: 1rem;;
}
.containerimgsingleStory {
  position: relative;
  text-align: center;
}
.image-inner-container {
    position: absolute;
}
.overlay {
    position: absolute;
    text-align: center;
    width: 100%;
}

.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
  justify-content: center
}


/*switch btn Create - view*/
.switch-field1{
	display: flex;
	margin-bottom: 0%;
	overflow: hidden;
}

.switch-field1 input {
	position: absolute !important;
	clip: rect(0, 0, 0, 0);
	height: 1px;
	width: 1px;
	border: 0;
	overflow: hidden;
}

.switch-field1 label {
  border-radius: 999rem;
  border: 2px solid transparent;
  width: 50%;
	color: rgba(0, 0, 0, 1);
	font-size: 14px;
	line-height: 1;
	text-align: center;
	padding: 4px 0px;
	/*margin-right: -1px;*/
	/*border: 1px solid rgba(0, 0, 0, 0.2);*/
	/*box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);*/
	transition: all 0.1s ease-in-out;
}

.switch-field1 label:hover {
	cursor: pointer;
}

.switch-field1 input:checked + label {

	border: 2px solid black;
  border-radius: 99rem;
	box-shadow: none;
}

.switch-field1 label:first-of-type {
	border-radius: 4px 0 0 4px;
}

.switch-field1 label:last-of-type {
	border-radius: 0 4px 4px 0;
}

/*switch btn saved  - Published*/

/*switch btn all  - nearMe*/
.switch-field3,.switch-field2 {

	color: rgba(0, 0, 0, 0.6);
	display: flex;

	overflow: hidden;
}

.switch-field3 input,.switch-field2 input {
	position: absolute !important;
	clip: rect(0, 0, 0, 0);
	height: 1px;
	width: 1px;
	border: 0;
	overflow: hidden;
}

.switch-field3 label,.switch-field2 label {
  width: 50%;

	/*background-color: #e5e5e5;
	color: rgba(0, 0, 0, 0.6);*/
	font-size: 14px;
	line-height: 1;
	text-align: center;
	padding: 4px 0px;
	/*border: 1px solid rgba(0, 0, 0, 0.2);*/
	/*box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);*/
	transition: all 0.1s ease-in-out;
}

.switch-field3 label:hover,.switch-field2 label:hover {
	cursor: pointer;
}

.switch-field3 input:checked + label,.switch-field2 input:checked + label {
	background-color: #000;
  color:#FFF;
  border-radius: 99rem;
	box-shadow: none;
}

.switch-field3 label:first-of-type,.switch-field2 label:first-of-type {
	border-radius: 4px 0 0 4px;
}

.v-radio.theme--light > label{
  margin-left: auto;
  margin-right: auto;
}
.theme--light.v-label{
  color: #38737A;
}
</style>

